module.exports = __webpack_public_path__ + "img/indu_active_12.a1c27a90.png";